module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/kansas-state-university-98f64dbd3fc82c4cdfded01f8ed3bb5b.jpg";